import React from 'react'
import '../css/About.css'

const About = () => {
  return (
    <div className="about-content">
      <div className="about-photo"></div>
      <h2>About me</h2>
      <p>Originally from Omaha, NE 🌽 now loving life in West Hollywood, CA for the last decade I moved here after graduating from the University of Iowa 🎓 with a Bachelor of Arts in Sociology and a certificate from the University of Iowa Tippie College of Business in Entrepreneurial Management.  Recently, in 2023, I also graduted from an intensive program at 💻 General Assembly studying software engineering.</p>
      <p>I am an extremely motivated software engineer, proud member of the LGBT+ 🌈 community, with a serious passion for technology discovered at an early age. Self-taught and independent learner, I achieved success as a freelance full-stack developer at the age of 12 through self-motivated learning and online resources becoming skilled in both back-end and front-end design using PHP/MySQL, HTML/CSS, JavaScript, AJAX/XML and Adobe Photoshop.</p>
      <p>What excites me most about development is when I am able to help others find solutions to seemingly complex issues as well as creating stunning experiences that amaze its users and inspire fellow developers.  Proven ability in object-oriented programming, graphic design, and use of popular frameworks and libraries.  I am a dedicated, independent learner and problem solver, seeking to jumpstart my career in software engineering by collaborating with a dynamic team to drive exceptional results and growth in a fast-paced industry.</p>
      <p>Thank you 🙌 for taking the time to visit my portfolio I truly hope we are able to connect soon.  In a nutshell I'd say I am a genuine, humble and charismatic person that will add value to your team with my experience, skill set, ideas and relentless determination to find leading solutions.</p>
      <p style={{marginTop:'50px'}}>
        <a href="/Resume.pdf" target="_blank" rel="noreferrer" style={{fontFamily:'Montserrat', fontSize:'18pt'}}>RESUME</a>
      </p>
      <p>
        <a href="/projects" style={{fontFamily:'Montserrat', fontSize:'18pt'}}>PROJECTS</a>
      </p>
      <p>
        <a href="/skills" style={{fontFamily:'Montserrat', fontSize:'18pt'}}>SKILLS</a>
      </p>
      <p>
        <a href="/contactme" style={{fontFamily:'Montserrat', fontSize:'18pt'}}>CONTACT ME</a>
      </p>
    </div>
  )
}

export default About
